const React = require('react');
const {default: OpenInNewIcon} = require('@material-ui/icons/OpenInNew');
const {default: IconButton} = require('@material-ui/core/IconButton');
const upperFirst = require('mn-utils/upperFirst');

const {
  LINK_ADMIN_ACCOUNT_ITEM,
  LINK_ADMIN_MPOS_CREDENTIALS,
  LINK_ADMIN_PAYOUT,
} = require('../../../../../../constants/links');
const MenuVertIcon = require('../../../../../icons/MenuVert');
const RowA = require('../../../../../dumb/Row/A');
const ColA = require('../../../../../dumb/Col/A');
const Ripple = require('../../../../../dumb/Ripple');
const {Link, pushLocation} = require('../../../../../../router');
const Menu = require('../../../../../dumb/Menu');
const {lifeFlowNames} = require('../../constants/lifeflowStatuses');
const {userRolesNames} = require('../../constants/userRoles');
const DownloadIcon = require("../../../../../icons/Download");
const {apiAdminAccountsKYCGet} = require("../../../../../../api/admin/accountsKYC");
const downloadKycPdf = require("../../../../../../utils/downloadKycPdf");
const {loadingSignOut$, getUserMainPage} = require("../../../../../../emitters/account");

const {
  DisplayIdAdmin,
  DisplayDataAdmin,
  DisplayDateTimeAdmin,
} = require('../../../../../dumb/DisplayData');

const openPopupLimits = require('./utils/openPopupLimits');
const {apiAuthAdminToMerchant} = require('../../../../../../api/_auth');
const {onAccount} = require('../../../../../../emitters/account');
const ButtonRegisterBPaySubmerchant = require('../../../../../dumb/Button/RegisterBPaySubmerchant');
const {USER_TYPE_MERCHANT} = require("../../../../../../constants/userTypes");

module.exports = ({data, update}) => {
  const submerchantId = data.bpay_submerchant_id;
  const id = data.id;
  const login = data.login;
  const lifeflow = data.lifeflow;
  const role = data.user_role;
  const updated = data.updated_at;
  const limits = data.limits || {};
  const status = data.status || '';

  const lifeflowIsReady = lifeflow === 'ready';
  const statusIsCompleted = ['approved', 'ready'].includes(status);

  const disableRelogin = (
    !lifeflowIsReady
    || data.blocked
    || !statusIsCompleted
    || login === 'admin@lunu.io'
  );

  return (
    <RowA>
      <ColA className="wmin170 fx1">
        <DisplayIdAdmin>{id}</DisplayIdAdmin>
      </ColA>
      <ColA className="wmin150 fx1">
        <DisplayDataAdmin>{login}</DisplayDataAdmin>
      </ColA>
      <ColA className="wmin120 fx1">
        <DisplayDataAdmin>{data.full_name}</DisplayDataAdmin>
      </ColA>
      <ColA className="wmin120 fx1">
        <DisplayDataAdmin>{userRolesNames[role]}</DisplayDataAdmin>
      </ColA>
      <ColA className="wmin150 fx1">
        <DisplayDataAdmin>
          {
            lifeflowIsReady && !statusIsCompleted
              ? upperFirst(status)
              : lifeFlowNames[lifeflow] || '-'
          }
        </DisplayDataAdmin>
      </ColA>
      <ColA className="wmin150 fx1">
        {limits.min_amount || limits.max_amount ? (
          <DisplayDataAdmin>
            {limits.min_amount || 0} EUR - {limits.max_amount || '∞'} EUR
          </DisplayDataAdmin>
        ) : 'None'}
      </ColA>
      <ColA className="wmin110">
        {updated ? <DisplayDateTimeAdmin date={updated}/> : '-'}
      </ColA>
      <ColA
        className="wmin90"
      >{data.blocked ? 'Yes' : 'No'}</ColA>
      <ColA className="wmin210">
        {role === 'merchant' && lifeflow === 'ready'
          ? <ButtonRegisterBPaySubmerchant id={id} submerchantId={submerchantId} update={update} />
          : '-'
        }
      </ColA>
      {/*<ColA className="wmin170">{submerchantId ? <DisplayIdAdmin>{submerchantId}</DisplayIdAdmin> : (*/}
      {/*    role === 'merchant' && lifeflow === 'ready' ? (*/}
      {/*        <ButtonRegisterBPaySubmerchant id={id} update={update} />*/}
      {/*    ) : '-'*/}
      {/*)}</ColA>*/}
      <ColA className="w155">
        {
          id ? (
            <div className="layoutRow fvaC fhaE mr-35">
              <Ripple
                className="layoutRow fhaC fvaC sq50 r olN tdN dB cF dn
                      bgF.03:h"
                centerRipple
                component={Link}
                href={LINK_ADMIN_ACCOUNT_ITEM + id}
              >
                <OpenInNewIcon/>
              </Ripple>
              <Ripple
                className="layoutRow fhaC fvaC sq50 r olN tdN dB cF dn
                      bgF.03:h"
                centerRipple
                onClick={() => {
                  apiAdminAccountsKYCGet({
                    skipError: 1,
                    account_id: id,
                  }).then(downloadKycPdf);
                }}
              >
                <DownloadIcon width="24" height="24" />
              </Ripple>
              <Menu
                transformOriginTop="right top"
                transformOriginBottom="right bottom"
                items={[
                  // {name: 'Update ', onClick() {
                  //   openPopupLimits({...data, update});
                  // }},
                  {name: 'Edit Limits', onClick() {
                    openPopupLimits({...data, update});
                  }},
                  role === USER_TYPE_MERCHANT && {
                    name: 'MPos credentials',
                    onClick() {
                      pushLocation({
                        path: LINK_ADMIN_MPOS_CREDENTIALS + id,
                      });
                    }
                  },
                  {name: 'Payout', onClick() {
                    pushLocation({
                      path: `${LINK_ADMIN_PAYOUT}/${id}`,
                    });
                  }},
                  {
                    name: `Login as ${data.login}`,
                    disabled: disableRelogin,
                    onClick() {
                      loadingSignOut$.emit(true);
                      return apiAuthAdminToMerchant({id})
                          .then(onAccount)
                          .then(() => {
                            pushLocation({
                              path: getUserMainPage(),
                            });
                          })
                          .then(() => {
                            setTimeout(() => {
                              loadingSignOut$.emit(false);
                            }, 500);
                          });
                    },
                  },
                ].filter((el) => !!el)}
              >
                <IconButton>
                  <div className="sq23 layoutRow fhaC fvaC">
                    <MenuVertIcon
                      className="w5 cF"
                    />
                  </div>
                </IconButton>
              </Menu>
            </div>
          ) : null
        }
      </ColA>
    </RowA>
  );
};
